import { render, staticRenderFns } from "./Strategies.vue?vue&type=template&id=09bd6c0f&"
import script from "./Strategies.vue?vue&type=script&lang=js&"
export * from "./Strategies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports